import React from "react";
import { Search, Loader2 } from "lucide-react";

export default function LandingHeroShowcase() {
  return (
<section className="relative bg-white -mt-6 md:-mt-8">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center px-6 md:px-10 pt-8 md:pt-12 pb-12 gap-10">
        {/* LEFT: Text Content */}
        <div className="flex-1 text-center md:text-left">
          <h1 className="text-5xl sm:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight">
            Find Quality{" "}
            <span className="bg-gradient-to-r from-yellow-500 to-orange-600 bg-clip-text text-transparent">
              Link Prospects
            </span>{" "}
            in Seconds.
          </h1>

          <p className="mt-5 text-lg text-gray-600 max-w-md md:max-w-lg mx-auto md:mx-0">
            Backlink Banana brings together live prospect data, site authority
            metrics, and LinkedIn outreach contacts, all in one dashboard.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
            <a
              href="/login"
              className="px-8 py-3.5 bg-yellow-400 text-gray-900 font-semibold rounded-lg shadow-md hover:shadow-lg hover:bg-yellow-300 transition-all duration-300"
            >
              Get 20 Free Credits
            </a>
          </div>
        </div>

        {/* RIGHT: Mock Search Demo */}
        <div className="flex-1 bg-gray-50 rounded-2xl shadow-xl border border-gray-100 p-6 md:p-8">
          {/* Search Bar */}
          <div className="flex items-center gap-2 border border-gray-300 rounded-xl p-3 mb-6 bg-white shadow-sm">
            <Search className="text-gray-400 w-5 h-5" />
            <input
              disabled
              value="site:blog + SaaS guest post"
              className="flex-1 bg-transparent outline-none text-gray-700 font-medium"
            />
            <Loader2 className="animate-spin text-yellow-500 w-5 h-5" />
          </div>

          {/* Mock Results */}
          <div className="space-y-4">
            {[
              { title: "Freshdesk Blog", da: 78, spam: "1%", linkedin: 8 },
              { title: "HubSpot Resources", da: 92, spam: "0%", linkedin: 10 },
              { title: "Supermetrics Blog", da: 74, spam: "2%", linkedin: 7 },
            ].map((r) => (
              <div
                key={r.title}
                className="p-4 border border-gray-200 rounded-xl bg-white shadow-sm hover:shadow-md transition-all duration-300"
              >
                <div className="flex justify-between items-center">
                  <p className="font-semibold text-gray-800">{r.title}</p>
                  <span className="text-sm text-gray-500">DA {r.da}</span>
                </div>
                <p className="text-sm text-gray-600 mt-1">
                  Spam Score {r.spam} · {r.linkedin} LinkedIn contacts
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
